var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSellingAqaba({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.351,
    height: 90.442,
    viewBox: "0 0 92.351 90.442",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9980",
    "data-name": "Group 9980",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9946",
    "data-name": "Path 9946",
    d: "M460.06,435.033l-23.087-22.489V435.02L429.047,429v12.059l7.927-6.022v22.478Z",
    transform: "translate(-367.71 -389.811)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9947",
    "data-name": "Path 9947",
    d: "M428.429,398.233l23.087,23.089H428.439l6.179,7.927H422.237l6.184-7.927H405.339Z",
    transform: "translate(-382.252 -398.233)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9948",
    "data-name": "Path 9948",
    d: "M445.752,449.941l-23.087-23.085V449.93l-7.928-6.178v12.381l7.928-6.186v23.086Z",
    transform: "translate(-376.488 -382.591)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9949",
    "data-name": "Path 9949",
    d: "M414.116,412.544l23.09,23.09h-23.08l6.18,7.925h-12.38l6.186-7.925H391.029Z",
    transform: "translate(-391.03 -390.176)",
    fill: "#00641f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellingAqaba);
export default __webpack_public_path__ + "static/media/sellingAqaba.b5abd18ae7345351d589d1dcb682c19f.svg";
export { ForwardRef as ReactComponent };